const PROJECT_STORAGE_KEY_PREFIX = 'promptlab.currentProjectId';
const ACTIVE_PROJECT_STORAGE_KEY = `${PROJECT_STORAGE_KEY_PREFIX}.active`;

const buildStorageKey = (userKey?: string | null) =>
  userKey ? `${PROJECT_STORAGE_KEY_PREFIX}.${userKey}` : PROJECT_STORAGE_KEY_PREFIX;

export const getCurrentProjectId = (userKey?: string | null): string | null => {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(buildStorageKey(userKey)) || window.localStorage.getItem(ACTIVE_PROJECT_STORAGE_KEY);
};

export const setCurrentProjectId = (projectId: string | null, userKey?: string | null) => {
  if (typeof window === 'undefined') return;
  const storageKey = buildStorageKey(userKey);
  if (!projectId) {
    window.localStorage.removeItem(storageKey);
    window.localStorage.removeItem(ACTIVE_PROJECT_STORAGE_KEY);
    return;
  }
  window.localStorage.setItem(storageKey, projectId);
  window.localStorage.setItem(ACTIVE_PROJECT_STORAGE_KEY, projectId);
};
